import { EntityType } from 'UI/constants/entityTypes';

import { CandidateDetail } from './CandidateDetail';
import { JobOrderDetail } from './JobOrderDetail';

export const QUERY_PARAMS_BY_ENTITY_TYPE = {
  Candidates: {
    ids: null,
    includes: 'specialty,subspecialty,position,personalInformation',
    page: 1,
    perPage: 100
  },
  JobOrders: {
    ids: null,
    page: 1,
    perPage: 100
  }
};

export const FOOTER_COMPONENT_MAP = {
  [EntityType.Joborder]: JobOrderDetail,
  [EntityType.Candidate]: CandidateDetail
};
